import login from './modules/login'
import applyManage from './modules/applyManage'
import applyAudit from './modules/applyAudit'
import system from './modules/system'
import stuApply from './modules/student/stuApply'
import examine from './modules/student/examine'



export default {
  login,
  applyManage,
  applyAudit,
  system,
  stuApply,
  examine,
}


